import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { IGreenhouse, IGreenhouses, IGreenhouseState } from "../interfaces/IGreenhouse";
import { GridSelectionModel } from "@mui/x-data-grid";
import { ISelection } from "../interfaces/ISelection";



const initialState: ISelection = {
    selection: []
}

export const selectionSlice = createSlice({
    name: 'selection',
    initialState,
    reducers: {
        setSelectionValues: (state, action: PayloadAction<ISelection>) => {
            state.selection = action.payload.selection;
        }
    }
})

export const {setSelectionValues} = selectionSlice.actions;

export const getSelections = (state: RootState) => state.selection;

export default selectionSlice.reducer;